<div class="signinContainer flex justify-start gap-0 overflow-y-auto rounded-[20px] bg-white shadow-lg">
  <app-image-side
    [imageSrc]="'assets/testlogo.png'"
    [title]="'Welcome Back!'"
    [description]="'Log in to access your account and continue where you left off.'"
    [type]="'login'" />

  <div class="bg-bg flex w-full flex-col gap-4 px-10 py-5">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="flex w-full flex-col gap-4">
      <div>
        <h1 class="text-[32px] font-semibold" i18n="@@loginTitle">Login</h1>
        <p class="text-[16px] font-normal" i18n="@@loginSubtitle">Please enter information to login</p>
      </div>
      @if (apiError()) {
        <app-error [apiError]="apiError()" />
      }

      <div>
        <app-mobile-input formControlName="mobileNumber" [error]="isFieldInvalid('mobileNumber')" />
        @if (hasError("mobileNumber", "required")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@loginPhoneRequired">Phone number is required</p>
        } @else if (hasError("mobileNumber", "invalidCharacters")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@loginPhoneInvalid">Mobile Number must contain only numbers</p>
        }
        <!-- @if () {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerMobileInvalidPatternNumber">Invalid mobile number</p>
        } -->
        @if (hasError("mobileNumber", "mobileNumber") || hasError("mobileNumber", "invalidLength")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@loginInvalidMobileNumberStartsWith0">Invalid mobile number</p>
        }
      </div>

      <div>
        <label for="password" class="cursor-pointer text-lg" i18n="@@loginPasswordLabel">Password</label>
        <div
          class="relative rounded-[10px] border-2"
          [class.border-gray-400]="!isFieldInvalid('password')"
          [class.border-red-500]="isFieldInvalid('password')">
          <input
            [type]="showPassword ? 'text' : 'password'"
            id="password"
            formControlName="password"
            class="w-[90%] border-none p-2 py-3 focus:outline-none"
            required />

          @if (!showPassword) {
            <svg
              (click)="showPassword = !showPassword"
              xmlns="http://www.w3.org/2000/svg"
              width="1.25em"
              height="1.25em"
              viewBox="0 0 24 24"
              [class]="isArabic() ? 'left-4' : 'right-4'"
              class="absolute top-1/2 -translate-y-1/2 cursor-pointer">
              <path
                class="stroke-gray-muted fill-gray-muted"
                d="M12 9.005a4 4 0 1 1 0 8a4 4 0 0 1 0-8m0 1.5a2.5 2.5 0 1 0 0 5a2.5 2.5 0 0 0 0-5M12 5.5c4.613 0 8.596 3.15 9.701 7.564a.75.75 0 1 1-1.455.365a8.504 8.504 0 0 0-16.493.004a.75.75 0 0 1-1.456-.363A10 10 0 0 1 12 5.5"
                stroke-width="0.5" />
            </svg>
          } @else {
            <svg
              (click)="showPassword = !showPassword"
              xmlns="http://www.w3.org/2000/svg"
              width="1.25em"
              height="1.25em"
              viewBox="0 0 16 16"
              [class]="
                'absolute top-1/2 -translate-y-1/2 cursor-pointer' +
                (currentLocale() === 'ar' ? ' left-4' : currentLocale() === 'en' ? ' right-4' : '')
              ">
              <path
                class="stroke-gray-muted fill-gray-muted"
                d="m10.12 10.827l4.026 4.027a.5.5 0 0 0 .708-.708l-13-13a.5.5 0 1 0-.708.708l3.23 3.23A6 6 0 0 0 3.2 6.182a6.7 6.7 0 0 0-1.117 1.982c-.021.061-.047.145-.047.145l-.018.062s-.076.497.355.611a.5.5 0 0 0 .611-.355l.001-.003l.008-.025l.035-.109a5.7 5.7 0 0 1 .945-1.674a5 5 0 0 1 1.124-1.014L6.675 7.38a2.5 2.5 0 1 0 3.446 3.446m-.74-.74A1.5 1.5 0 1 1 7.413 8.12zM6.32 4.2l.854.854Q7.564 5 8 5c2.044 0 3.286.912 4.028 1.817a5.7 5.7 0 0 1 .945 1.674q.025.073.035.109l.008.025v.003l.001.001a.5.5 0 0 0 .966-.257v-.003l-.001-.004l-.004-.013a2 2 0 0 0-.06-.187a6.7 6.7 0 0 0-1.117-1.982C11.905 5.089 10.396 4 8.002 4c-.618 0-1.177.072-1.681.199"
                stroke-width="0.5" />
            </svg>
          }

          <!-- <i
            class="fa-solid password-eye-icon"
            [class.fa-eye]="!showPassword"
            [class.fa-eye-slash]="showPassword"
            (click)="showPassword = !showPassword"></i> -->
        </div>

        @if (hasError("password", "required")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerPasswordRequired">Password is required</p>
        } @else if (hasError("password", "minlength")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerPasswordMinLength">
            Password must be at least 8 characters
          </p>
        } @else if (hasError("password", "maxlength")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerPasswordMaxLength">
            Password must be at most 50 characters
          </p>
        } @else if (hasError("password", "passwordMissingLowercase")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerPasswordLowercase">
            Password must contain at least one lowercase letter
          </p>
        } @else if (hasError("password", "passwordMissingUppercase")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@passwordMissingUppercase">
            Password must contain at least one uppercase letter
          </p>
        } @else if (hasError("password", "passwordMissingNumber")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@passwordMissingNumber">
            Password must contain at least one number
          </p>
        } @else if (hasError("password", "passwordMissingSpecial")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerPasswordSpecial">
            Password must contain at least one special character (! &#64; # $ % ^ &amp; * ( ) &#123; &#125; [ ] - _ = +
            &#47; &#92; ~ . &lt; &gt; : ; &quot; &#39;)
          </p>
        } @else if (hasError("password", "passwordContainsSpaces")) {
          <p class="mt-1 text-sm text-red-600" i18n="@@registerPasswordSpaces">Password cannot contain spaces</p>
        }
      </div>
      <div class="mt-3 flex w-full justify-end">
        <button type="submit" [disabled]="loading()" class="btn-primary">
          @if (loading()) {
            <span i18n="@@loginButtonLoading">LOADING...</span>
          } @else {
            <span i18n="@@loginButtonText">LOGIN</span>
          }
        </button>
      </div>
    </form>
    <div class="flex w-full justify-start">
      <a
        routerLink="/forgot-password"
        class="text-text-strong w-[135px] cursor-pointer text-[16px] font-light underline"
        i18n="@@loginForgotPassword">
        Forgot password?
      </a>
    </div>
    <div class="text-text-strong mt-auto flex flex-col items-center justify-center text-[16px]">
      <span i18n="@@loginNoAccount">Don't have an account?</span>
      <a routerLink="/register" class="text-text-strong cursor-pointer text-[14px] underline" i18n="@@loginSignupNow">
        Signup now
      </a>
    </div>
  </div>
</div>
